<template>
  <CommonPopup
    ref="refCommonPopup"
    :show-close-btn="true"
  >
    <div class="pay-check-popup">
      <div class="pay-check-popup-content">
        <div class="pay-check-title">确认充值号码</div>
        <div class="pay-check-value">{{ chargeNumber }}</div>
        <div class="pay-check-tips">
          请确认该手机号为您{{
            providerName
          }}小程序账户的手机号，充值成功后无法换绑以及退款。
        </div>
      </div>
      <div class="pay-check-popup-btns">
        <div
          class="pay-check-popup-btn btn-default"
          @click="handleCancel"
        >
          修改号码
        </div>
        <div
          class="pay-check-popup-btn btn-primary"
          @click="handleConfirm"
        >
          确认充值
        </div>
      </div>
    </div>
  </CommonPopup>
</template>

<script>
import CommonPopup from './CommonPopup';

export default {
  name: 'PayCheckPopup',
  components: {
    CommonPopup
  },
  props: {
    chargeNumber: {
      type: String,
      default: ''
    },
    providerName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    openPopup() {
      this.$refs.refCommonPopup.openPopup();
      this.$emit('open');
    },
    closePopup() {
      this.$refs.refCommonPopup.closePopup();
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-check-popup {
  background: #ffffff;
  border-radius: 20px;
  width: 600px;
  box-sizing: border-box;
  padding: 32px;
  padding-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .pay-check-popup-content {
    margin-bottom: 48px;
    width: 100%;

    .pay-check-title {
      font-size: 40px;
      color: #383838;
      text-align: center;
      font-weight: bold;
      margin-bottom: 48px;
    }
    .pay-check-value {
      font-size: 42px;
      color: #383838;
      line-height: 45px;
      font-weight: 400;
      text-align: center;
      margin-bottom: 24px;
      font-weight: bold;
      letter-spacing: 2px;
    }
    .pay-check-tips {
      font-size: 32px;
      color: #ff722c;
      font-weight: 400;
      line-height: 36px;
    }
  }
  .pay-check-popup-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .pay-check-popup-btn {
      width: 252px;
      height: 90px;
      border-radius: 20px;
      font-size: 32px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;

      &.btn-default {
        border: 1px solid rgba(200, 200, 200, 1);
        background: #ffffff;
        color: #383838;
      }
      &.btn-primary {
        background: #fe7256;
        color: #ffffff;
      }
    }
  }
}
</style>
